// Signup failures become field + error_type. The message text is never stored.

const FIELDS = new Set([
  "email",
  "password",
  "re_password",
  "first_name",
  "last_name",
  "non_field",
  "form",
]);

export function classifySignupErrorValue(value) {
  const text = String(value || "");
  if (/already exist|already registered|already linked|unique/i.test(text)) return "already_used";
  if (/too short|at least \d|min_length/i.test(text)) return "too_short";
  if (/too common/i.test(text)) return "too_common";
  if (/too similar/i.test(text)) return "too_similar";
  if (/entirely numeric/i.test(text)) return "numeric";
  if (/do not match|didn't match|mismatch/i.test(text)) return "mismatch";
  if (/blank|required|may not be/i.test(text)) return "required";
  if (/valid email|invalid/i.test(text)) return "invalid";
  return "invalid";
}

function fieldName(key) {
  const name = String(key || "").trim().toLowerCase();
  if (name === "non_field_errors") return "non_field";
  if (name.includes("@")) return "form";
  return FIELDS.has(name) ? name : "form";
}

function messageText(value) {
  if (Array.isArray(value)) return value.filter((item) => typeof item === "string").join(" ");
  return typeof value === "string" ? value : "";
}

export function signupFieldErrors(data, { status = 0, network = false } = {}) {
  if (network) return [{ field: "form", error_type: "request_failed" }];
  if (Number(status) === 429) return [{ field: "form", error_type: "rate_limited" }];
  if (typeof data === "string") {
    return [{ field: "form", error_type: classifySignupErrorValue(data) }];
  }
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return [{ field: "form", error_type: "invalid" }];
  }
  const keys = Object.keys(data).filter((key) => key !== "detail" || Object.keys(data).length === 1);
  if (!keys.length) return [{ field: "form", error_type: "invalid" }];
  return keys.map((key) => ({
    field: fieldName(key),
    error_type: classifySignupErrorValue(messageText(data[key])),
  }));
}
